import { createSelector } from '@ngrx/store';
import { EntitySexoState, entitytSexoAdapter } from './entity-sexo.state';
import {
  VistaUsuarioState,
  selectVistaUsuario
} from '../../vista-usuario/vista-usuario.state';

const { selectAll, selectEntities } = entitytSexoAdapter.getSelectors();

export const getError = (state: EntitySexoState): any => state.error;

export const getIsLoading = (state: EntitySexoState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntitySexoState): boolean =>
  state.hasAddedSuccess;

export const selectEntitySexoState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.sexo
);

export const selectAllSexos = createSelector(selectEntitySexoState, selectAll);

export const selectAllEntitySexo = createSelector(
  selectEntitySexoState,
  selectAll
);

export const selectEntityMaquinaMovil = createSelector(
  selectEntitySexoState,
  selectEntities
);

export const selectSexosIsLoading = createSelector(
  selectEntitySexoState,
  getIsLoading
);

export const selectAllSexosPublicos = createSelector(selectAllSexos, (sexos) =>
  sexos.filter((sexo) => sexo.publico).sort((a, b) => a.id - b.id)
);

export const selectTiposIdentidadGeneroPrivado = createSelector(
  selectAllSexos,
  (sexos) => sexos.filter((sexo) => !sexo.publico)
);

export const selectSexoById = (id: number) =>
  createSelector(selectAllSexos, (allSexos) =>
    allSexos.find((s) => s.id == id)
  );
